export const formatUSDWithUSAndSymbol = (value: number) => {
  const formattedCurrency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
  return formattedCurrency.replace(/\$/g, "US$");
};

export const formatUSDCompactAndSymbol = (value: number) => {
  const nFormatted = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 2,
  }).format(value);
  return `$${nFormatted}`;
};

export const formatUSDWithoutSymbol = (value: number) => {
  const formattedCurrency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
  return formattedCurrency.replace(/\$/g, "");
};
